import React, { memo } from 'react';
import { Modal, Form } from 'react-bootstrap';

const SpecialityModal = ({
  show,
  onHide,
  submitClick,
  speciality_data,
  selectSpeciality,
  selectedSpeciality
}) => {
  return (
    <Modal className="fade rightModal medWikiFilterModal p-0" size="sm" show={show} onHide={onHide}>
      <Modal.Header className="bg-primary position-relative rounded-0 border-0 p-4">
        <Modal.Title className="text-white fs-3">Select Specialities</Modal.Title>
        <span
          className="modalClose rounded-circle cursorPointer text-white position-absolute top-50 translate-middle-y d-flex justify-content-center align-items-center"
          onClick={submitClick}
        >
          ok
        </span>
      </Modal.Header>
      <Modal.Body className="bg-white py-20 px-4 overflow-y-auto">
        {speciality_data && speciality_data.length > 0
          ? speciality_data.map((_sp, _spIdx) => (
              <div className="medWikiFilterModalCheck" key={_spIdx + 1}>
                <Form.Check
                  type="radio"
                  name="specialitySelector"
                  className="gtm_cl_userProfile_specialityModal_speciality_check"
                  checked={
                    selectedSpeciality?.master_specialities_id === _sp.master_specialities_id
                  }
                  label={_sp.specialities_name}
                  // id={_sp.master_specialities_id}
                  onChange={() => {
                    console.warn('specialityId', _sp, _sp.master_specialities_id);

                    selectSpeciality(_sp, _sp.master_specialities_id);
                  }}
                />
              </div>
            ))
          : null}
        {/* <div className="d-flex flex-wrap centerModalBttns">
          <button
            className="col fs-4 btn btn-danger py-3 px-4 userProfile_emailModal_cancel"
            type="button"
            aria-label="Cancel"
            onClick={onHide}
          >
            Cancel
          </button>
          <button
            className="col fs-4 btn btn-primary py-3 px-4 userProfile_emailModal_submit"
            type="button"
            onClick={submitClick}
            aria-label="Submit"
          >
            Submit
          </button>
        </div> */}
      </Modal.Body>
    </Modal>
  );
};

export default memo(SpecialityModal);
